import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

// import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import ValidatingFormSubmitButton from '../../../../../../components/Button/FormSubmitButton';
// import { CustomDatePicker } from '../../../../../../components/Form/CustomDatePicker';
import CustomFileUploader from '../../../../../../components/Form/CustomFileUploader';
import { FormComponent } from '../../../../../../components/Form/FormComponent';
import { TextInputField } from '../../../../../../components/Form/FormField';
// import useCreateVerification from '../../../../../../hooks/dashboard/settings/profilesetting/useCreateVerification';
import useCreateVerification from '../../../../../../hooks/profilesetting/useCreateVerification';
import {
  VerificationDataType,
  VerificationInitialValues,
  VerificationSchema,
} from '../../../../../../models/profileSettings/Verification.model';
import { useAppSelector } from '../../../../../../redux/store';
import { LoadingOutlined } from '@ant-design/icons';
// import useEditVerification from '../../../../../../hooks/dashboard/settings/profilesetting/useEditVerification';

interface VerificationFormProps {
  setEditVerification?: (...args: any) => void;
  editVerification?: 'edit' | 'new';
  onViewTable: () => void;
}

const VerificationForm: React.FC<VerificationFormProps> = ({
  setEditVerification,
  editVerification,
  onViewTable,
}) => {
  const { authData } = useAppSelector((state) => state.auth);

  const license = authData?.license;

  const { loading, createVerification } = useCreateVerification();

  // const { loading: editing, editVerification: editVery } =
  //   useEditVerification();

  const [initialVerificationValue, setInitialVerificationValue] = useState(
    VerificationInitialValues
  );

  const cancelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (editVerification && license) {
      setInitialVerificationValue(license);
    } else {
      setInitialVerificationValue(VerificationInitialValues);
    }

    // eslint-disable-next-line
  }, [editVerification]);

  const handleSubmit = async (values: VerificationDataType) => {
    console.log(
      'editVerification prop at submit:',
      editVerification,
      values.facilityId
    );

    if (editVerification === 'edit') {
      // await editVery(values).then(() => {
      //   setTimeout(() => {
      //     cancelRef?.current?.click();
      //   }, 2000);
      // });
      alert('work in progress');
      return;
    } else {
      await createVerification(values).then(() => {
        setTimeout(() => {
          cancelRef?.current?.click();
        }, 3000);
      });
    }
  };

  if (!initialVerificationValue) {
    return (
      <div>
        <LoadingOutlined />
      </div>
    );
  }

  return (
    <FormComponent
      initialValues={initialVerificationValue}
      schema={VerificationSchema}
      onSubmit={handleSubmit}
    >
      <FieldGroups>
        <CustomFileUploader label="CAC" name="cacCertificate" />
        <TextInputField
          label="Facility unique identity number"
          name="facilityId"
          type="text"
          placeholder="Facility ID"
        />
      </FieldGroups>

      <FieldGroups>
        <CustomFileUploader label="Operating license" name="license" />
      </FieldGroups>

      <FieldGroups
        className={clsx('submit-btn', editVerification ? '' : 'single')}
      >
        {/* {editVerification && ( */}
        <CancelBtn
          onClick={() => {
            setEditVerification && setEditVerification(false);
          }}
          ref={cancelRef}
        >
          Cancel
        </CancelBtn>
        {/* )} */}
        <ValidatingFormSubmitButton loading={loading} className="small">
          Save
        </ValidatingFormSubmitButton>
      </FieldGroups>
    </FormComponent>
  );
};

export default VerificationForm;

const FieldGroups = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }

  &.submit-btn {
    margin-top: 3rem;
    display: flex;
    justify-content: space-between;

    &.single > * {
      margin-top: 3rem;
      margin-left: auto;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr 1fr;

      & > * {
        padding: 8px 32px;
        gap: 16px;
      }
    }
  }
`;

const CancelBtn = styled.div`
  background: ${({ theme }) => theme.palette.stateColorRed};
  color: white;
  cursor: pointer;
  width: fit-content;
  border-radius: 4px;
  display: flex;
  justify-self: flex-start;
  padding: 8px 48px;
  font-weight: 500;
  font-size: 14px;
`;
